class ShortlistCandidate {
  constructor(
    firstName,
    lastName,
    currentJobTitle,
    currentCompany,
    currentCompanyURL,
    currentLocation,
    desiredSalary,
    resumeURL,
    coverLetterURL,
    linkedinURL,
    githubURL,
    twitterURL,
    interpersonalSkills,
    technicalSkills,
    summary,
    educationRanking,
    careerExperienceRanking,
    technicalSkillsRanking,
    careerAccomplishmentsRanking,
    companyFitRanking,
    locationFitRanking,
  ) {
    this.firstName = firstName
    this.lastName = lastName
    this.currentJobTitle = currentJobTitle
    this.currentCompany = currentCompany
    this.currentCompanyURL = currentCompanyURL
    this.currentLocation = currentLocation
    this.desiredSalary = desiredSalary
    this.resumeURL = resumeURL
    this.coverLetterURL = coverLetterURL
    this.linkedinURL = linkedinURL
    this.githubURL = githubURL
    this.twitterURL = twitterURL
    this.interpersonalSkills = interpersonalSkills
    this.technicalSkills = technicalSkills
    this.summary = summary
    this.candidateRanking = {}
    this.candidateRanking.education = educationRanking
    this.candidateRanking.careerExperience = careerExperienceRanking
    this.candidateRanking.technicalSkills = technicalSkillsRanking
    this.candidateRanking.careerAccomplishments = careerAccomplishmentsRanking
    this.candidateRanking.companyFit = companyFitRanking
    this.candidateRanking.locationFit = locationFitRanking
  }
}

export default ShortlistCandidate